import React, {useEffect} from 'react';
import SearchConditions from './SearchConditions';
import SpellList from './SpellList';
import axios from 'axios';
import {URL, PATH, AUTH} from '../config';

let SearchPage = ({spellList, setSpellList, searchFilters, setSearchFilters}) => {


  useEffect(() => {

  });

  let setFilters = (newFilters) =>{
    setSearchFilters(newFilters);
  }

  let search = () => {
    console.log("Setting out to deliver your request to Wizard!")
    let request = requestBuilder();
    console.log(request);
    axios.get(request, {headers: {'Authorization': `Bearer ${AUTH}`}})
      .then((res) => {
        setSpellList(res.data.results);
        //TODO Maybe Make it class specific!~
        console.log(`The Wizard has provided a list of ${res.data.results.length} spells for you to peruse! Supposedly these will answer your query...`)})
      .catch((err) => { console.error(err) });
  }

  let requestBuilder = () => {
    console.log("Writing your request to the Grand Wizard upon an ancient scroll!")
    console.log("The wizard lives at " + URL);


    let request = `https://${URL + PATH}list?spellClass=${searchFilters['class']}&low=${searchFilters['level-lo']}&high=${searchFilters['level-hi']}`;

    if (searchFilters['school']) {
      request += '&school=' + searchFilters['school'];
    }
    if (searchFilters['subschool']) {
      request += '&subschool=' + searchFilters['subschool'];
    }
    if (searchFilters['tag'].length > 0) {
      request += '&tag=' + searchFilters['tag'];
    }
    if (searchFilters['verbal']) {
      request += '&v=' + searchFilters['verbal'];
    }
    if (searchFilters['somatic']) {
      request += '&s=' + searchFilters['somatic'];
    }
    if (searchFilters['material']) {
      request += '&m=' + searchFilters['material'];
    }
    if (searchFilters['cost']) {
      request += '&cost=' + searchFilters['cost'];
    }
    if (searchFilters['spellFocus']) {
      request += '&spellFocus=' + searchFilters['spellFocus'];
    }
    if (searchFilters['divineFocus']) {
      request += '&divineFocus=' + searchFilters['divineFocus'];
    }

    return request;
  }


  return (
    <div className="search-page">
      <SearchConditions currentFilters={searchFilters} setFilters={setFilters}/>

      <button type="button" className="btn" onClick={search}>
        <strong>Search</strong>
      </button>

      <SpellList spells={spellList}/>

    </div>
  )
};
export default SearchPage;
